"use client";

import type { ReactNode } from "react";
import { useReveal } from "@/lib/use-reveal";

/**
 * Wraps a grid (or any container) to fade + slide it in when it scrolls
 * into view. Pass `stagger` to cascade direct children (60ms apart).
 */
export function Reveal({
  children,
  className = "",
  stagger = false,
}: {
  children: ReactNode;
  className?: string;
  stagger?: boolean;
}) {
  const { ref, className: revealClass } = useReveal<HTMLDivElement>({ stagger });
  return (
    <div ref={ref} className={`${revealClass} ${className}`.trim()}>
      {children}
    </div>
  );
}
